import React from 'react';
export function TermsPage() {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-584">
      <div className="max-w-3xl mx-auto" data-id="element-585">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-586">
          Términos y Condiciones
        </h1>

        <div className="space-y-6 text-base text-gray-600 leading-relaxed" data-id="element-587">
          <div className="text-center mb-8" data-id="element-588">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-589">
              Términos y Condiciones de Uso Tarjeta CLUBAHORRA
            </h2>
          </div>

          <section data-id="element-590">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-591">
              1. NATURALEZA DEL PROGRAMA
            </h3>
            <p data-id="element-592">
              El presente documento establece los términos y condiciones
              aplicables al uso de la tarjeta de fidelización gratuita
              denominada CLUBAHORRA (en adelante, "la Tarjeta"), la cual permite
              a sus titulares acceder a beneficios, descuentos y promociones
              ofrecidos por comercios afiliados al programa.
            </p>
          </section>

          <section data-id="element-593">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-594">
              2. ACCESO A LA TARJETA
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-595">
              <li data-id="element-596">
                La Tarjeta es gratuita y de uso personal e intransferible.
              </li>
              <li data-id="element-597">
                Podrá acceder a ella cualquier persona natural mayor de edad que
                complete el formulario de afiliación correspondiente.
              </li>
              <li data-id="element-598">
                El uso de la Tarjeta implica la aceptación plena de estos
                términos y condiciones.
              </li>
            </ul>
          </section>

          <section data-id="element-599">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-600">
              3. BENEFICIOS Y PROMOCIONES
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-601">
              <li data-id="element-602">
                Los beneficios ofrecidos pueden incluir: descuentos directos,
                promociones especiales, servicios preferenciales, obsequios u
                otros incentivos, según lo determine cada comercio afiliado.
              </li>
              <li data-id="element-603">
                Cada comercio es el único responsable de aplicar, mantener,
                modificar o cancelar los beneficios que ofrece a los usuarios de
                la Tarjeta.
              </li>
              <li data-id="element-604">
                Los beneficios están sujetos a condiciones particulares propias
                de cada comercio (vigencia, stock, montos mínimos de compra,
                restricciones, etc.).
              </li>
            </ul>
          </section>

          <section data-id="element-605">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-606">
              4. RESPONSABILIDAD DEL PROGRAMA
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-607">
              <li data-id="element-608">
                TicketMaestro SAS, empresa procesadora de la plataforma Benefika
                y de La Tarjeta, actúa únicamente como intermediario que conecta
                a los usuarios con comercios aliados, sin asumir responsabilidad
                por la calidad, disponibilidad o condiciones de los productos o
                servicios ofrecidos.
              </li>
              <li data-id="element-609">
                En caso de cualquier inconveniente o reclamo relacionado con los
                beneficios, el usuario deberá comunicarse directamente con el
                comercio correspondiente.
              </li>
            </ul>
          </section>

          <section data-id="element-610">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-611">
              5. VIGENCIA Y MODIFICACIONES
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-612">
              <li data-id="element-613">
                La vigencia de la Tarjeta es indefinida, salvo que el usuario o
                la organización emiten renuncien expresamente a su uso.
              </li>
              <li data-id="element-614">
                La organización se reserva el derecho de modificar, suspender o
                cancelar el programa o sus términos y condiciones, informando
                oportunamente a los usuarios a través de sus canales oficiales.
              </li>
            </ul>
          </section>

          <section data-id="element-615">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-616">
              6. PROTECCIÓN DE DATOS PERSONALES
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-617">
              <li data-id="element-618">
                Al afiliarse, el usuario autoriza el tratamiento de sus datos
                personales conforme a la legislación vigente, exclusivamente
                para fines informativos y promocionales relacionados con el
                programa.
              </li>
              <li data-id="element-619">
                Los datos no serán compartidos con terceros sin consentimiento
                del titular, salvo requerimiento legal. Puede ver más detalles
                en el documento de nuestras Políticas de Privacidad y Protección
                de Datos Personales.
              </li>
            </ul>
          </section>

          <section data-id="element-620">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-621">
              7. USO INDEBIDO Y CANCELACIÓN
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-622">
              <li data-id="element-623">
                El uso fraudulento, indebido o contrario a estos términos puede
                dar lugar a la anulación inmediata de la Tarjeta y la pérdida de
                sus beneficios.
              </li>
              <li data-id="element-624">
                La organización podrá retirar o suspender la tarjeta en caso de
                mal uso sin necesidad de notificación previa.
              </li>
            </ul>
          </section>

          <section data-id="element-625">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-626">
              8. VIGENCIA
            </h3>
            <p data-id="element-627">
              La vigencia de estos Términos y Condiciones de Uso es desde el 12
              de septiembre de 2025 y permanecerá vigente hasta que exista una
              nueva versión que la reemplace.
            </p>
          </section>

          <div className="pt-8 mt-8 border-t border-gray-200 text-sm text-gray-500" data-id="element-628">
            Última actualización: 12 de septiembre de 2025
          </div>
        </div>
      </div>
    </div>;
}